// src/components/ProgressWidget.js

import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';

// Registreer de onderdelen die Chart.js nodig heeft voor een Doughnut chart
ChartJS.register(ArcElement, Tooltip, Legend);

const ProgressWidget = ({ completed, inProgress, total }) => {
  // Bereken het aantal nog niet begonnen doorloopjes
  const notStarted = Math.max(0, total - completed - inProgress);

  const data = {
    labels: ['Afgerond', 'Bezig', 'Nog niet begonnen'],
    datasets: [
      {
        data: [completed, inProgress, notStarted],
        backgroundColor: [
          '#28a745', // Groen voor afgerond
          '#ffdd00', // Geel voor bezig
          '#d0d2d3', // Grijs voor nog niet begonnen
        ],
        borderColor: [
          '#ffffff',
          '#ffffff',
          '#ffffff',
        ],
        borderWidth: 2,
        hoverOffset: 4,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    cutout: '70%', // Maakt de 'donut hole' in het midden groter
    plugins: {
      legend: {
        display: false, // We verbergen de standaard legende om een custom te maken
      },
      tooltip: {
        callbacks: {
          label: function(context) {
            let label = context.label || '';
            if (label) {
              label += ': ';
            }
            if (context.parsed !== null) {
              label += context.parsed;
            }
            return label;
          }
        }
      }
    },
  };

  const legendItems = [
    { label: 'Afgerond', value: completed, color: '#28a745' },
    { label: 'Bezig', value: inProgress, color: '#ffdd00' },
    { label: 'Nog niet begonnen', value: notStarted, color: '#d0d2d3' },
  ];

  return (
    <div className="widget-card progress-widget">
      <div className="progress-chart-container">
        <Doughnut data={data} options={options} />
        <div className="chart-center-text">
          <strong>{total}</strong>
          <span>Totaal</span>
        </div>
      </div>
      <div className="progress-legend">
        <h3>Voortgang</h3>
        <ul>
          {legendItems.map(item => (
            <li key={item.label} className="legend-item">
              <span className="legend-color-dot" style={{ backgroundColor: item.color }}></span>
              <span className="legend-text">{item.label}</span>
              <span className="legend-count">{item.value}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default ProgressWidget;